import { getJquery } from '../js/util'

const statesObj = require('../js/lib/states')

const { L } = window

let $ = getJquery()

export default {
	init() {
		const $body = $('body')

		const stars = window.profStars
		const $mapEl = $('#map')
		// const mapHeight = $mapEl.height()
		const $searchResults = $('#search_results')
		const $searchBar = $('#searchbar')
		let resultsHtml = ''

		// make map
		const map = L.map($mapEl[0], {
			// center: [39.882335, -97.135337],
			// zoom: 5,
			// scrollWheelZoom: false,
		})
		map.zoomControl.setPosition('bottomright')
		getDefaultMapLayer().addTo(map)

		// locate user
		map.locate()
		map.on('locationfound', function (e) {
			// var radius = e.accuracy / 2
			L.marker(e.latlng).addTo(map).bindPopup('You are here!')
			// L.circle(e.latlng, radius).addTo(map)
			// map.flyTo(e.latlng, 9)
		})

		// get coords from el attribute
		const markerCoords = stars.map((star) => {
			return star.coords ? star.coords.split(',') : false
		})

		// set star map icon
		const icon = L.icon({
			iconUrl: $('[rel=icon]')
				.attr('href')
				.replace('favicon.png', 'marker.png'),
			iconSize: [30, 30],
			iconAnchor: [15, 30],
			popupAnchor: [0, -31],
		})
		const distIcon = L.icon({
			iconUrl: $('[rel=icon]')
				.attr('href')
				.replace('favicon.png', 'marker-distributors.png'),
			iconSize: [30, 30],
			iconAnchor: [15, 30],
			popupAnchor: [0, -31],
		})

		stars.forEach((star, i) => {
			const { name, email, addressTwo, phone, coords, dist } = star
			let state
			if (!coords) {
				return
			}
			const coordArr = coords.split(',')
			// const directionsUrl = `https://www.google.com/maps/dir/Current+Location/${addressOne}, ${addressTwo}`
			let popupContent = `
				<h6>${name}</h6>
				<p>${addressTwo}</p>`
			if (phone) {
				popupContent += `<p><strong>${phone}</strong></p>`
			}
			if (email) {
				popupContent += `<a href="mailto:${email}" target="_blank" class="btn">Send Email</a>`
			}
			const marker = L.marker(coordArr, {
				icon: dist ? distIcon : icon,
				zIndexOffset: dist ? 99 : 9,
			})
			const popup = L.popup().setContent(popupContent)
			marker.bindPopup(popup)
			marker.addTo(map)

			// add marker to star
			star.marker = marker

			// get state full name
			if (~addressTwo.indexOf(',')) {
				const stateAbbr = addressTwo.split(', ')[1].split(' ')[0]
				if (stateAbbr.length === 2) {
					state = statesObj[stateAbbr.toUpperCase()]
				}
			}
			star.content = `${name} ${addressTwo} ${state}`.toLowerCase()

			// add star to island
			resultsHtml += `
				<div data-marker-index="${i}">
					<h6>${name}</h6>
					<p>${addressTwo}</p>
					<p><strong>${phone}</strong></p>
				</div>`
		})
		$searchResults.html(resultsHtml)

		// fit map to markers
		map.fitBounds(markerCoords)

		// results click event - center to marker and open popup
		$body.on('click', '[data-marker-index]', function () {
			const $this = $(this)
			const index = $this.attr('data-marker-index')
			const { marker, coords } = stars[index]
			map.flyTo(coords.split(','))
			marker.openPopup()
		})

		// searchbar change filter event
		$searchBar.on('input', filterResults)
		// filter function
		function filterResults() {
			const val = $searchBar.val().toLowerCase()
			let resultsHtml = ''
			// const matchedStars = stars
			stars.forEach((star, i) => {
				const { content, marker, name, addressTwo, phone } = star
				if (!content) {
					return
				}
				const matched = ~content.indexOf(val)
				if (!matched) {
					marker.setOpacity(0.07)
				} else {
					marker.setOpacity(1)
					resultsHtml += `
					<div data-marker-index="${i}">
					<h6>${name}</h6>
					<p>${addressTwo}</p>
					<p><strong>${phone}</strong></p>
					</div>`
				}
			})
			$searchResults.html(resultsHtml)
		}
	},
	finalize() {},
}

function getDefaultMapLayer() {
	// return L.tileLayer('https://cartodb-basemaps-{s}.global.ssl.fastly.net/light_all/{z}/{x}/{y}.png', {
	// 	maxZoom: 18,
	// 	// attribution: '&copy; <a href="http://openstreetmap.org">OpenStreetMap contributors</a>',
	// 	attribution: "Map tiles by Carto, under CC BY 3.0. Data by OpenStreetMap, under ODbL.",
	// })
	return L.tileLayer(
		'https://api.mapbox.com/styles/v1/{id}/tiles/{z}/{x}/{y}?access_token={accessToken}',
		{
			attribution:
				'Map data &copy; <a href="http://openstreetmap.org">OpenStreetMap</a> contributors, <a href="http://creativecommons.org/licenses/by-sa/2.0/">CC-BY-SA</a>, Imagery © <a href="http://mapbox.com">Mapbox</a>',
			maxZoom: 18,
			id: 'mapbox/light-v10',
			accessToken:
				'pk.eyJ1IjoiYm9vc3RjcmVhdGl2ZWxsYyIsImEiOiJjbGI1YW1oZTUwNG90M29yemYxNW9nN2s3In0.PffNIBOLYqtnl4Ut4XebsA',
		}
	)
}
